module.exports = __webpack_public_path__ + "static/media/home.cfe62932.svg";